import React, { forwardRef, useRef } from 'react';
import propTypes from 'prop-types';

const Checkbox = forwardRef(
  (
    {
      id,
      value = false,
      onChange,
      label = '',
      subLabel = '',
      classes,
      disabled,
      ...rest
    },
    forwardedRef
  ) => {
    const inputRef = useRef(null);

    return (
      <div className='flex' ref={inputRef || forwardedRef}>
        <div className={`${label ? 'mr-2' : ''}`}>
          <input
            id={`${id}-${label}`}
            className='align-middle h-4 w-4 mb-0.5'
            type='checkbox'
            name={label}
            checked={Boolean(value)}
            onChange={(event) => onChange(event.target.checked)}
            disabled={disabled}
            style={{
              ...(disabled && !value
                ? {
                  filter: 'brightness(0.7)'
                }
                : {})
            }}
            {...rest}
          />
        </div>
        <div className='flex flex-col'>
          <label
            htmlFor={`${id}-${label}`}
            className={`align-middle mb-0 ${classes}`}
          >
            {label}
          </label>
          {subLabel ? <p className='text-sm mb-0'>{subLabel}</p> : null}
        </div>
      </div>
    );
  }
);

Checkbox.propTypes = {
  onChange: propTypes.func.isRequired
};

export default Checkbox;
